import config from '../../config.json';

/**
 * Where the activity upload lives, relative to the API gateway (LMSNEXT-1286).
 *
 * Both platforms take the path from here, so neither has it welded into a native binary: iOS is
 * handed the full URL, Android the path through `configureNetworking`. An environment that routes
 * differently — dev serves paths, staging and production serve `/function/<service>` — is then a
 * matter of configuration rather than a store release.
 *
 * The default lives in code, not config.json, because the deploy scripts regenerate that file: a
 * key they don't know about would be undefined in every deployed environment. `activityUploadPath`
 * only has to be added to those scripts for the environment that needs a different one.
 */
export const DEFAULT_ACTIVITY_UPLOAD_PATH = 'function/services-activity-upload';

export const activityUploadPath = config.activityUploadPath || DEFAULT_ACTIVITY_UPLOAD_PATH;

/** The full upload URL, for the iOS plugin, which takes a URL rather than a path. */
export function activityUploadUrl(gatewayBaseUrl) {
  return `${String(gatewayBaseUrl).replace(/\/+$/, '')}/${activityUploadPath}`;
}
